export default "__VITE_ASSET__B79jml$W__"